import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@/lib/axios'
import { toast } from 'sonner'

export interface MediaFile {
    filename: string
    originalName: string
    mimetype: string
    size: number
    path: string
    url: string
    createdAt: string
}

export function useMedia() {
    const queryClient = useQueryClient()

    // Fetch all media
    const mediaQuery = useQuery({
        queryKey: ['media'],
        queryFn: async () => {
            const res = await axios.get<MediaFile[]>('/upload/media')
            return res.data
        },
    })

    // Upload new media
    const uploadMutation = useMutation({
        mutationFn: async (file: File) => {
            const formData = new FormData()
            formData.append('media', file)
            const res = await axios.post<{ message: string; media: MediaFile }>('/upload/site-media', formData)
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['media'] })
            toast.success('Medya başarıyla yüklendi')
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message || 'Medya yüklenirken bir hata oluştu')
        },
    })

    // Delete media
    const deleteMutation = useMutation({
        mutationFn: async (filePath: string) => {
            const res = await axios.delete('/upload/media', { data: { filePath } })
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['media'] })
            toast.success('Medya başarıyla silindi')
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message || 'Medya silinirken bir hata oluştu')
        },
    })

    return {
        media: mediaQuery.data || [],
        isLoading: mediaQuery.isLoading,
        isError: mediaQuery.isError,

        uploadMedia: uploadMutation.mutateAsync,
        isUploading: uploadMutation.isPending,

        deleteMedia: deleteMutation.mutateAsync,
        isDeleting: deleteMutation.isPending,
    }
}
